<template>
  <div class="wrap">
    <dl class="tip primary">
      <dt class="text-bold"><i class="el-icon-bell" />操作提示</dt>
      <dd class="text-info">需要先选择客户单位后，方可添加商品清单</dd>
      <dd class="text-info">
        商品清单已过滤：满足条件“订单已核定”、“商品未发货”
      </dd>
    </dl>
    <div class="form">
      <el-form
        ref="ff"
        v-loading="loading"
        :model="parcel"
        label-position="top"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="客户单位" prop="CustomerId" required>
              <customerPicker
                v-model="parcel.CustomerName"
                clearable
                style="width: 100%"
                @change="pickCustomer"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系人" prop="Linkman">
              <el-input v-model="parcel.Linkman" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="地址" prop="Linkman">
              <el-input v-model="parcel.Address" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="电话" prop="Linktel">
              <el-input v-model="parcel.Linktel" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-card
          shadow="never"
          body-style="padding:0"
          style="margin-bottom: 20px"
        >
          <div slot="header" class="toolbar">
            <h3>商品清单</h3>
            <el-link type="primary" icon="el-icon-plus" @click="pickGoods"
              >添加商品</el-link
            >
          </div>
          <el-table :data="parcel.Items">
            <el-table-column width="60" align="center">
              <template slot-scope="scope">
                <el-link
                  type="danger"
                  :underline="false"
                  class="el-icon-remove"
                  style="font-size: 20px"
                  @click="onRemove(scope)"
                />
              </template>
            </el-table-column>
            <el-table-column label="库存编码" min-width="100">
              <template slot-scope="{ row }">
                {{ $utils.meta.format("branch", row.Stock) }}
                {{ row.Code }}
              </template>
            </el-table-column>
            <el-table-column prop="Name" label="商品名称" min-width="200" />
            <el-table-column prop="Unit" label="单位" align="center" width="60">
              <template slot-scope="{ row }">
                {{ row.Amount }}{{ row.Unit }}
              </template>
            </el-table-column>
          </el-table>
        </el-card>
        <el-form-item prop="Remark" label="订单备注">
          <el-input type="textarea" :rows="5" v-model="parcel.Remark" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit()">提交订单</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import goodsPicker from "@/views/mall/sold/_picker.vue";
export default {
  components: {
    customerPicker: () => import("@/views/company/customer/_picker.vue"),
  },
  data() {
    return {
      loading: false,
      parcel: {
        Items: [],
      },
    };
  },
  created() {
    this.loadData(this.$route.params?.id);
  },
  methods: {
    loadData(id) {
      if (!id || this.loading) {
        return;
      }
      this.loading = true;
      this.$apis.mall.parcel
        .info({
          id: id,
          goods: true,
        })
        .then((res) => {
          if (res != null) {
            this.parcel = res;
          } else {
            this.$router.go(-1);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //选择客户
    pickCustomer(res) {
      this.$set(this.parcel, "CustomerId", res.Id);
      this.$set(this.parcel, "CustomerName", res.Name);
      this.$set(this.parcel, "Linkman", res.Linkman);
      this.$set(this.parcel, "Linktel", res.Linktel);
      this.$set(this.parcel, "Address", res.Address);
      this.$set(this.parcel, "Items", []);
    },
    //选择商品
    pickGoods() {
      if (this.parcel.CustomerId) {
        this.$layer.iframe({
          title: "选择商品",
          area: ["720px", "600px"],
          content: {
            content: goodsPicker,
            parent: this,
            data: {
              customer: this.parcel.CustomerId,
              callback: (res) => {
                res.forEach((item) => {
                  let index = this.parcel.Items.findIndex(
                    (x) =>
                      x.OrderId == item.OrderId &&
                      x.GoodsId == item.GoodsId &&
                      x.ParentId == item.ParentId
                  );
                  if (index != -1) {
                    this.parcel.Items.splice(index, 1);
                  }
                  if (item.Amount > 0) {
                    this.parcel.Items.push(item);
                  }
                });
              },
            },
          },
        });
      } else {
        this.$message.error("请先选择客户单位...");
      }
    },
    //移除商品行
    onRemove(row) {
      this.parcel.Items.splice(row.$index, 1);
    },
    onSubmit() {
      this.$refs["ff"].validate((valid) => {
        if (valid && !this.loading) {
          this.loading = true;
          this.$apis.mall.parcel
            .submit(this.parcel)
            .then((res) => {
              this.$message({ message: "数据提交成功！", type: "success" });
              this.$router.replace({ path: `/mall/parcel/detail/${res.Id}` });
            })
            .catch((e) => {
              this.$message.error(e || "执行错误");
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  display: flex;
  flex-direction: column;
  min-width: 720px;
  .form {
    padding: 30px;
    background-color: #fff;
    flex: 1;
    .el-form {
      min-width: 640px;
      width: 72%;
      margin: 0 auto;
    }
  }
}
</style>
